/**
 * Static-translations for fr. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const fr = {
  'anon.description_default': 'Configuration de votre session invité…',
  'anon.heading_default': 'Continuer en tant qu\'invité',
  'anon.try_again': 'Réessayer',
  'auth.back_to_login': 'Retour à la connexion',
  'auth.check_email_message': 'Vérifiez votre e-mail pour le code de confirmation.',
  'auth.check_email_title': 'Vérifiez votre e-mail',
  'auth.confirm_email_subtitle': 'Entrez le code que nous avons envoyé à votre e-mail pour finaliser votre compte.',
  'auth.confirm_email_title': 'Confirmez votre e-mail',
  'auth.confirmation_code': 'Code de confirmation',
  'auth.continue_with_apple': 'Continuer avec Apple',
  'auth.continue_with_facebook': 'Continuer avec Facebook',
  'auth.continue_with_github': 'Continuer avec GitHub',
  'auth.continue_with_google': 'Continuer avec Google',
  'auth.create_account': 'Créer un compte',
  'auth.default_subtitle': 'Connectez-vous pour accéder à toutes les fonctionnalités et synchroniser vos données.',
  'auth.email': 'Adresse e-mail',
  'auth.email_already_registered': 'Cet e-mail est déjà enregistré. Connectez-vous ci-dessous avec votre mot de passe ou le compte utilisé lors de l\'inscription.',
  'auth.email_exists': 'Un compte avec cet e-mail existe déjà.',
  'auth.email_not_confirmed': 'Veuillez d\'abord confirmer votre e-mail.',
  'auth.forgot_password': 'Mot de passe oublié ?',
  'auth.forgot_password_title': 'Mot de passe oublié ?',
  'auth.forgot_subtitle': 'Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation du mot de passe.',
  'auth.generic_error': 'Une erreur s\'est produite',
  'auth.have_account': 'Vous avez un compte ?',
  'auth.hide_password': 'Masquer le mot de passe',
  'auth.identity_already_linked': 'Ce compte est déjà enregistré. Connectez-vous avec ci-dessous.',
  'auth.invalid_credentials': 'E-mail ou mot de passe invalide',
  'auth.invalid_otp': 'Le code est invalide ou a expiré.',
  'auth.last_used': 'Dernière fois · {email}',
  'auth.last_used_no_email': 'Dernière fois',
  'auth.link_purchase_subheading': 'Nous lierons l\'achat à votre compte pour conserver l\'accès.',
  'auth.log_in': 'Se Connecter',
  'auth.log_in_link': 'Se Connecter',
  'auth.login_continue_purchase': 'Connectez-vous pour continuer votre achat',
  'auth.network_error': 'Erreur réseau. Vérifiez votre connexion et réessayez.',
  'auth.new_password_optional': 'Nouveau mot de passe (optionnel — uniquement pour réinitialisation)',
  'auth.no_account': 'Vous n\'avez pas de compte ?',
  'auth.or': 'ou',
  'auth.password': 'Mot de passe',
  'auth.passwords_mismatch': 'Les mots de passe ne correspondent pas',
  'auth.rate_limited': 'Trop de requêtes. Réessayez plus tard.',
  'auth.repeat_password': 'Répéter le mot de passe',
  'auth.reset_link_valid': 'Le lien est valide pendant 1 heure.',
  'auth.reset_password_subtitle': 'Entrez le code de votre e-mail et un nouveau mot de passe.',
  'auth.reset_password_title': 'Réinitialiser le mot de passe',
  'auth.reset_sent_message': 'Si cet e-mail existe, un code de réinitialisation a été envoyé.',
  'auth.reset_sent_subtitle': 'Nous avons envoyé un lien de réinitialisation. Suivez les instructions de l\'e-mail.',
  'auth.restore_purchases_heading': 'Restaurer les Achats',
  'auth.restore_purchases_subheading': 'Veuillez vous connecter pour restaurer vos achats.',
  'auth.send_reset': 'Envoyer l\'E-mail de Réinitialisation',
  'auth.service_unavailable': 'Service temporairement indisponible. Réessayez plus tard.',
  'auth.show_password': 'Afficher le mot de passe',
  'auth.sign_out': 'Se déconnecter',
  'auth.sign_up': 'S\'inscrire',
  'auth.sign_up_link': 'S\'inscrire',
  'auth.signed_in': 'Connecté',
  'auth.signin_failed': 'Échec de la connexion',
  'auth.signup_failed': 'Échec de l\'inscription',
  'auth.verify': 'Vérifier',
  'auth.weak_password': 'Le mot de passe est trop faible.',
  'auth.welcome': 'Bienvenue !',
  'auth.welcome_signup': 'Bienvenue !',
  'cta.close': 'Fermer',
  'cta.continue': 'Continuer',
  'cta.get_lifetime_access': 'Obtenir un accès à vie',
  'cta.get_plan_daily': 'Obtenir le plan quotidien',
  'cta.get_plan_generic': 'Obtenir le plan {interval}',
  'cta.get_plan_monthly': 'Obtenir le plan mensuel',
  'cta.get_plan_weekly': 'Obtenir le plan hebdomadaire',
  'cta.get_plan_yearly': 'Obtenir le plan annuel',
  'cta.start_trial': 'Commencer l\'Essai Gratuit de {days} Jours',
  'modal.close_aria': 'Fermer',
  'modal.continue': 'Continuer',
  'modal.error_generic': 'Une erreur s\'est produite',
  'modal.loading': 'Chargement…',
  'modal.purchase_restored_subtitle': 'Tout est prêt — profitez-en !',
  'modal.purchase_restored_title': 'Bon retour',
  'modal.purchase_success_subtitle': 'Tout est prêt — profitez-en !',
  'modal.purchase_success_title': 'Paiement reçu',
  'modal.verifying_subscription': 'Vérification de votre abonnement…',
  'nav.back': '← Retour',
  'nav.back_aria': 'Retour',
  'offer.limited_time': 'Offre à durée limitée',
  'payment.awaiting_subtitle': 'Nous détecterons votre paiement automatiquement — ou cliquez ci-dessous une fois terminé.',
  'payment.awaiting_title': 'Finalisez le paiement dans le nouvel onglet',
  'payment.checking': 'Vérification…',
  'payment.ive_paid': 'J\'ai payé',
  'payment.open_checkout_again': 'Rouvrir le paiement',
  'payment.open_checkout_button': 'Ouvrir le paiement',
  'payment.popup_blocked_message': 'Votre navigateur a bloqué l\'onglet de paiement. Cliquez ci-dessous pour l\'ouvrir.',
  'payment.popup_blocked_title': 'Autorisez les pop-ups pour continuer',
  'payment.popup_help_text': 'La fenêtre de paiement ne s\'est pas ouverte ou a été bloquée ? Cliquez ici pour la rouvrir.',
  'payment.still_processing': 'Le paiement est toujours en cours de traitement. Réessayez dans un instant.',
  'payment.tab_closed_retry': 'Onglet fermé ? Réessayer',
  'pricing.free_trial_days': 'Essai gratuit de {days} jours',
  'pricing.included_per': 'Inclus par {interval}:',
  'pricing.interval.day': 'jour',
  'pricing.interval.lifetime_short': 'à vie',
  'pricing.interval.month': 'mois',
  'pricing.interval.period': 'période',
  'pricing.interval.week': 'semaine',
  'pricing.interval.year': 'an',
  'pricing.money_back': 'Garantie de remboursement de 30 jours',
  'pricing.most_popular': 'Le plus populaire',
  'pricing.no_prices': 'Aucun tarif disponible.',
  'pricing.plan_label.daily': 'PLAN QUOTIDIEN',
  'pricing.plan_label.lifetime': 'à vie',
  'pricing.plan_label.monthly': 'forfait mensuel',
  'pricing.plan_label.weekly': 'forfait hebdomadaire',
  'pricing.plan_label.yearly': 'forfait annuel',
  'pricing.plans_aria': 'Plans',
  'session.contact_support': 'Contacter le support',
  'session.restore_purchases': 'Restaurer les achats',
  'session.sign_out': 'Se déconnecter',
  'session.signed_in_as_prefix': 'Connecté en tant que',
  'session.signing_out': 'Déconnexion…',
  'support.attachments_aria': 'Téléverser des pièces jointes',
  'support.attachments_label': 'Pièces jointes',
  'support.close_button': 'Fermer',
  'support.done_button': 'Terminé',
  'support.dropzone_text': 'Déposez les images ici ou cliquez pour sélectionner',
  'support.email_placeholder': 'Entrez votre adresse e-mail',
  'support.file_requirements': 'JPEG/PNG/WebP, jusqu\'à {max} fichiers, ≤ {size} Mo chacun',
  'support.heading': 'Support',
  'support.instruction': 'Veuillez remplir le formulaire ci-dessous pour soumettre votre demande de support.',
  'support.invalid_email': 'Adresse e-mail invalide',
  'support.invalid_file': 'JPEG/PNG/WebP uniquement, ≤ {size} Mo chacun',
  'support.message_length': '1–5000 caractères',
  'support.message_placeholder': 'Entrez votre message',
  'support.remove_file_aria': 'Supprimer {filename}',
  'support.required': 'Requis',
  'support.send_another': 'Envoyer une autre demande',
  'support.send_button': 'Envoyer',
  'support.sending': 'Envoi en cours…',
  'support.sending_as': 'Envoi en tant que',
  'support.subject_length': '3–200 caractères',
  'support.subject_placeholder': 'Entrez votre sujet',
  'support.success_heading': 'Demande soumise',
  'support.success_message_prefix': 'Nous avons reçu votre message et répondrons à',
  'support.too_many_files': 'Jusqu\'à {max} fichiers'
} as const;

export default fr;
